// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__kWVSd","hand":"Intro_hand__-bYzn"};